var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4546 12.3637C10.3432 12.3645 10.2334 12.336 10.1365 12.281L6.00009 9.91372L1.86373 12.281C1.7668 12.337 1.65683 12.3664 1.54491 12.3663C1.43299 12.3661 1.32308 12.3365 1.22627 12.2804C1.12945 12.2242 1.04916 12.1435 0.99349 12.0464C0.937819 11.9493 0.908739 11.8393 0.909185 11.7274V2.18191C0.909185 1.84436 1.04328 1.52064 1.28196 1.28195C1.52064 1.04327 1.84436 0.90918 2.18191 0.90918H9.81827C10.1558 0.90918 10.4795 1.04327 10.7182 1.28195C10.9569 1.52064 11.091 1.84436 11.091 2.18191V11.7274C11.091 11.8961 11.024 12.058 10.9046 12.1773C10.7853 12.2967 10.6234 12.3637 10.4546 12.3637Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.7c186950bcf64e60e971cfe63979bfdf.svg";
export { ForwardRef as ReactComponent };